let state = {};

state.phanHoi = {
    refreshFnCountNew: 0,
};

state.currentUser = {};

state.reloadModalDetailHL7 = 0;

state.dataSearchUser = {
    reload: 0,
    isResult: false,
    data: {}
};

state.dataUser = {};

export default state;